<iim-card [header]="demandHeader" [footer]="demandFooter">
  <ng-template #demandHeader>
    <h3 class="mb-0 fw-normal">
      <em class="fas fa-user"></em>
      {{ 'Bedarfsmeldungen' | translate }}
    </h3>
  </ng-template>
  <div class="col ps-2">
    <div class="row mb-2">
      <div class="col">
        @if (openPurchaseRequisitionCount > 0) {
          <span class="fs-xs">
            {{
            'Sie haben \{\{count\}\} offene Bedarfsmeldungen'
            | translate: { count: openPurchaseRequisitionCount }
            }}
          </span>
        }
        @if (openPurchaseRequisitionCount === 0) {
          <div class="alert alert-success mb-0 fs-xs">
            {{ 'Sie haben keine offenen Bedarfsmeldungen!' | translate }}
          </div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col">
        @if (hasUnannouncedDemand) {
          <div class="alert alert-info mb-1 fs-xs">
            {{ 'Sie haben einen unveröffentlichten Bedarf!' | translate }}
          </div>
        }
      </div>
    </div>
  </div>
  <ng-template #demandFooter>
    @if (!showOnTheWidgetCard) {
      <div class="col">
        <div class="row justify-content-end">
          <div class="col-auto p-0">
            @if (!hasUnannouncedDemand) {
              <button
                class="btn btn-sm btn-secondary"
                [routerLink]="'/' + View.CLIENT + '/rfq/demand/create'"
                >
                <em class="fas fa-plus pe-1"></em>
                {{ 'neuen Bedarf melden' | translate }}
              </button>
            }
            @if (hasUnannouncedDemand) {
              <button
                class="btn btn-sm btn-primary"
                [routerLink]="'/' + View.CLIENT + '/rfq/demand/create'"
                >
                <em class="fas fa-pen pe-1"></em>
                {{ 'bestehenden Bedarf bearbeiten' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    }
  </ng-template>
</iim-card>
